export default function (jqElement) {

    const options = parseJson(jqElement.attr('data-options')) || {};

    return {
        table: {
            minSpareRows: 1,
            outsideClickDeselects: false,
            ...options.table,
            removeRowPlugin: options.table.removeRowPlugin && !options.table.readOnly,
            rowHeaders: true, // safeguard because mergeCells + fixedColumnsLeft causes bug
            colHeaders: true, // safeguard because mergeCells + fixedRowsTop causes bug,
        },
        api: {
            ...options.api
        }
    }
}

function parseJson(json) {
    try {
        if (json) {
            return JSON.parse(json);
        }
    } catch (error) {
        console.log(error);
    }
    return {};
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/options.js